/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AcceptCashbackRequestForAdminCommand } from '../models/AcceptCashbackRequestForAdminCommand';
import type { CashbackRequestReviewContextViewModel } from '../models/CashbackRequestReviewContextViewModel';
import type { CashbackRequestViewModel } from '../models/CashbackRequestViewModel';
import type { CashbackRequestViewModelPaginatedListViewModel } from '../models/CashbackRequestViewModelPaginatedListViewModel';
import type { CommandSuccessViewModel } from '../models/CommandSuccessViewModel';
import type { CreateAdtractionClaimForCashbackRequestForAdminCommand } from '../models/CreateAdtractionClaimForCashbackRequestForAdminCommand';
import type { CreateImpactClaimForCashbackRequestForAdminCommand } from '../models/CreateImpactClaimForCashbackRequestForAdminCommand';
import type { DeclineCashbackRequestForAdminCommand } from '../models/DeclineCashbackRequestForAdminCommand';
import type { GetCashbackRequestForAdminQuery } from '../models/GetCashbackRequestForAdminQuery';
import type { GetCashbackRequestReviewContextForAdminQuery } from '../models/GetCashbackRequestReviewContextForAdminQuery';
import type { ListCashbackRequestsForAdminQuery } from '../models/ListCashbackRequestsForAdminQuery';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CashbackRequestsAdminService {
    /**
     * @param requestBody
     * @returns CashbackRequestViewModelPaginatedListViewModel Success
     * @throws ApiError
     */
    public static postApiCashbackRequestsAdminList(
        requestBody?: ListCashbackRequestsForAdminQuery,
    ): CancelablePromise<CashbackRequestViewModelPaginatedListViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/cashback-requests-admin/list',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns CashbackRequestViewModel Success
     * @throws ApiError
     */
    public static postApiCashbackRequestsAdminGet(
        requestBody?: GetCashbackRequestForAdminQuery,
    ): CancelablePromise<CashbackRequestViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/cashback-requests-admin/get',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * Benefits, business terms and the customer's history with this business in one call, so pricing a
     * request does not mean opening Contentful and the customer's profile alongside the dashboard.
     * @param requestBody
     * @returns CashbackRequestReviewContextViewModel Success
     * @throws ApiError
     */
    public static postApiCashbackRequestsAdminReviewContext(
        requestBody?: GetCashbackRequestReviewContextForAdminQuery,
    ): CancelablePromise<CashbackRequestReviewContextViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/cashback-requests-admin/review-context',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns CommandSuccessViewModel Success
     * @throws ApiError
     */
    public static postApiCashbackRequestsAdminAccept(
        requestBody?: AcceptCashbackRequestForAdminCommand,
    ): CancelablePromise<CommandSuccessViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/cashback-requests-admin/accept',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns CommandSuccessViewModel Success
     * @throws ApiError
     */
    public static postApiCashbackRequestsAdminDecline(
        requestBody?: DeclineCashbackRequestForAdminCommand,
    ): CancelablePromise<CommandSuccessViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/cashback-requests-admin/decline',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns CommandSuccessViewModel Success
     * @throws ApiError
     */
    public static postApiCashbackRequestsAdminCreateAdtractionClaim(
        requestBody?: CreateAdtractionClaimForCashbackRequestForAdminCommand,
    ): CancelablePromise<CommandSuccessViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/cashback-requests-admin/create-adtraction-claim',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns CommandSuccessViewModel Success
     * @throws ApiError
     */
    public static postApiCashbackRequestsAdminCreateImpactClaim(
        requestBody?: CreateImpactClaimForCashbackRequestForAdminCommand,
    ): CancelablePromise<CommandSuccessViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/cashback-requests-admin/create-impact-claim',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
}
